import * as providerPartVerification from './partVerification';
import * as providerStockOrders from './stockOrders';
import * as providerManualOrder from './manualOrders';
import * as providersOrdersManagement from './management';
import * as providersOrdersManagementDetail from './managementDetail';
import * as providerOrdersList from './specials';
import * as providerSequenceConfig from './sequenceConfig';
import * as amountReportDetail from './amountReport';
import * as amountTotals from './amountTotals';
import * as providerOrdersAuthorization from './authorization';
import * as providersImportations from './importations';

export const providerOrders = {
  ...providerPartVerification,
  ...providerStockOrders,
  ...providerManualOrder,
  ...providersOrdersManagement,
  ...providersOrdersManagementDetail,
  ...providerOrdersList,
  ...providerSequenceConfig,
  ...amountReportDetail,
  ...amountTotals,
  ...providerOrdersAuthorization,
  ...providersImportations,
};
